module.exports = __webpack_public_path__ + "static/media/ctb2.68ecf7ef.jpg";